<script setup>
import { inject, computed } from 'vue'
import '@/assets/style/editorView.css'

const props = defineProps({
  html: { type: String, default: '' }
})

const size = inject('size')
const isMobile = computed(() => ['s', 'xs'].includes(size.value))
const _html = computed(() => handle(props.html))

const letslazyload = (str) => {
  let regexp1 = new RegExp(/(<img )([^>]*)(src=")([^"]*")([^>]*)(>)/, 'g')
  let res = str.replace(regexp1, function (match, p1, p2, p3, p4, p5, p6) {
    return p1 + p2 + 'data-src="' + p4 + p5 + p6
  })
  return res
}

const handle = (value) => {
  try {
    const res = new DOMParser().parseFromString(value, 'text/html')
    const imgNodes = res.querySelectorAll('img')
    for (const target of imgNodes) {
      const desc = target.dataset?.desc
      const href = target.dataset?.href
      let imgHtml = letslazyload(target.outerHTML)
      // 处理图片链接和描述
      if (href) {
        imgHtml = `<a class="tvb-img_href" href="${href}" target="_self" rel="follow" >${imgHtml}</a>`
      }
      imgHtml = `<figure class="tvb-img_des-wrap">${imgHtml}${
        desc ? `<figcaption class='tvb-img_des'>${desc}</figcaption>` : ''
      }</figure>`
      target.outerHTML = imgHtml
    }

    return res.body.innerHTML
  } catch (error) {
    return value
  }
}
</script>

<template>
  <div
    v-html="_html"
    v-lazy-container="{ selector: 'img' }"
    class="editor-content-view vote-editor-content-view"
    :class="{ 'vote-editor-content-view-mobile': isMobile }"
  ></div>
</template>

<style lang="scss" scoped>
.vote-editor-content-view {
  text-align: justify;
  letter-spacing: 0.8px;
  font-size: 18px;
  line-height: 32px;

  :deep(img[lazy='error']),
  :deep(img[lazy='loading']) {
    background-color: #f8f9fa;
    aspect-ratio: 16 / 9;
    padding: 0 calc(50% - (98px / 2));
    width: 100%;
    object-fit: contain;
  }

  /* 图片处理 */
  :deep(.tvb-img_href) {
    text-decoration: none;
  }

  :deep(.tvb-img_des) {
    margin-top: 10px;
    font-size: 16px;
    color: #818d95;
    line-height: 22px;
    letter-spacing: 0.5px;
    display: block;
    word-break: break-all;
  }
}

.vote-editor-content-view-mobile {
  letter-spacing: 0.3px;
  font-size: 15px;
  line-height: 24px;

  :deep(img) {
    pointer-events: auto;
  }

  :deep(.tvb-img_des) {
    margin-top: 8px;
    font-size: 15px;
    letter-spacing: 0px;
  }
}
</style>
